import { DeviceFingerprint, SessionInfo } from "./attributionTracker.types";

export enum TrackingEventType {
  PV = "PV",
  EVENT = "EVENT",
}
/**
 * 埋点事件类型枚举
 */
export enum TrackingEvent {
  PV = "PV",
  /** 落地页点击 - 点击落地页或邀请拦截页的安装按钮且处于内置浏览器中 */
  PWA_INSTALL_CLICK = "PWA_INSTALL_CLICK",
  /** 落地页点击事件 */
  LANDING_PAGE_CLICK = "LANDING_PAGE_CLICK",
  /** 注册开始 - 点击注册按钮 */
  APPLY_REGISTER = "APPLY_REGISTER",
  /** 注册成功 */
  REGISTER_SUCCESS = "REGISTER_SUCCESS",
  /** 登陆开始 - 点击登陆按钮 */
  APPLY_LOGIN = "APPLY_LOGIN",
  /** 登陆成功 */
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  /** PWA安装完成 - appinstalled事件且小于4000ms */
  PWA_INSTALL_SUCCESS = "PWA_INSTALL_SUCCESS",
  /** 注册失败 */
  REGISTER_FAILED = "REGISTER_FAILED",
  /** 登陆失败 */
  LOGIN_FAILED = "LOGIN_FAILED",
}

/**
 * 埋点事件请求参数
 */
export interface TrackingEventRequest {
  /** 临时用户ID */
  uid?: string;
  /** 唯一链路AUUID */
  auuid?: string;
  /** 事件类型 */
  event: TrackingEvent;
  eventType: TrackingEventType;
  /** 事件详情 */
  eventDetail?: string;
  /** 用户ID - 登陆后传递 */
  userId?: string;

  // ==================== 浏览器与设备信息 ====================
  /** 浏览器指纹（必传） */
  browserFingerprint: string;

  // ==================== 页面信息 ====================
  /** 事件发生时的域名 */
  domain?: string;
  /** 事件发生时的路径 (不含查询参数) */
  path?: string;
  /** 事件发生时的完整链接 */
  fullUrl?: string;
  /** 页面referrer */
  referrer?: string;

  // ==================== 用户来源信息 ====================
  /** 用户来源: FACEBOOK, TIKTOK, GOOGLE */
  userSource?: string;
  /** UTM参数 */
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmTerm?: string;

  // ==================== 终端信息 ====================
  /** 终端类型: BROWSER, APP, PWA */
  terminalType?: string;
  /** 操作系统: IOS, ANDROID, WINDOWS, MACOS, LINUX, OTHER */
  operatingSystem?: string;
  /** 操作系统版本 */
  osVersion?: string;
  /** 浏览器类型 */
  browserType?: string;
  /** 浏览器版本 */
  browserVersion?: string;
  /** 是否在WebView中 */
  isWebView?: boolean;
  /** 终端设备品牌 */
  deviceBrand?: string;
  /** 终端设备型号 */
  deviceModel?: string;
  /** User Agent */
  userAgent?: string;

  // ==================== 代理信息 ====================
  /** 代理类型: NORMAL(普通), ADS(投放) */
  agentType?: string;
  /** 代理ID */
  agentId?: string;

  // ==================== 网络信息 ====================
  /** 网络环境: WIFI, _2G, _3G, _4G, _5G, UNKNOWN */
  networkType?: string;

  // ==================== 扩展信息 ====================
  /** 屏幕分辨率 */
  screenResolution?: string;
  /** 屏幕尺寸 */
  screenSize?: string;
  /** 语言 */
  language?: string;
  /** 时区 */
  timezone?: string;
  /** Facebook相关token */
  fbp?: string;
  fbc?: string;
  /** Google相关ID */
  gclid?: string;
  /** TikTok相关ID */
  ttclid?: string;

  /** 错误消息 - 失败事件传递 */
  message?: string;

  /** 设备指纹详细数据 */
  fingerprintData?: DeviceFingerprint | null;
  /** 会话信息 */
  session?: SessionInfo | null;
}

/**
 * 埋点事件响应
 */
export interface TrackingEventResponse {
  success: boolean;
  message?: string;
}
